module.exports = __webpack_public_path__ + "static/media/quiz-question-bubble.e38b1003.png";